var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computed, ref } from "vue";
import { useWorkflowStore } from "@/stores/workflowStore";
import { errorMessageAsString } from "@/utils/simple-error";
export function useWorkflowInstance(workflowId) {
    const workflowStore = useWorkflowStore();
    const workflow = computed(() => workflowStore.getStoredWorkflowByInstanceId(workflowId));
    const loading = ref(false);
    const error = ref(null);
    function getWorkflowInstance() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!workflow.value) {
                loading.value = true;
                try {
                    yield workflowStore.fetchWorkflowForInstanceId(workflowId);
                }
                catch (e) {
                    error.value = errorMessageAsString(e);
                }
                finally {
                    loading.value = false;
                }
            }
        });
    }
    getWorkflowInstance();
    return { workflow, loading, error };
}
